export const translations = {
  vi: {
    brand: 'Prompt.stv.vn',
    nav: {
      home: 'Trang chủ',
      explore: 'Khám phá',
      submit: 'Đăng bài',
      admin: 'Quản trị',
      searchPlaceholder: 'Tìm kiếm prompt...',
      signIn: 'Đăng nhập',
      profile: 'Tài khoản',
      logout: 'Đăng xuất',
      mobilePost: 'Đăng prompt',
    },
    auth: {
      welcome: 'Chào mừng trở lại',
      sub: 'Đăng nhập để truy cập thư viện prompt của bạn',
      login: 'Đăng nhập',
      register: 'Đăng ký',
      email: 'Email',
      password: 'Mật khẩu',
      name: 'Tên hiển thị',
      loginBtn: 'Đăng nhập ngay',
      registerBtn: 'Tạo tài khoản',
      loginSuccess: 'Đăng nhập thành công!',
      registerSuccess: 'Đăng ký thành công!',
      invalidCredentials: 'Email hoặc mật khẩu không đúng',
      registerError: 'Email đã được sử dụng',
      unauthorizedAdmin: 'Bạn không có quyền truy cập trang quản trị',
      sessionExpired: 'Phiên làm việc đã hết hạn',
    },
    home: {
      searchSuggestEmpty: 'Chưa có gợi ý phù hợp',
      liveInsight: 'Toàn cảnh nhanh',
      promptReady: 'prompt sẵn sàng',
      models: 'Mô hình',
      categories: 'Danh mục',
      likes: 'Lượt thích',
      views: 'Lượt xem',
      latestEyebrow: 'Mới nhất',
      latestTitle: 'Danh sách prompt mới',
      latestSubtitle: 'Ưu tiên hiển thị sớm trên mobile để người dùng vào là thấy ngay nội dung mới nhất.',
      viewAll: 'Xem tất cả',
      noNewPrompts: 'Chưa có prompt mới.',
      quickFindEyebrow: 'Tìm nhanh',
      trendingTitle: 'Prompt đang được dùng nhiều',
      trendingSubtitle: 'Giữ thêm một dải tham khảo sau phần prompt mới, nhưng không lấn át mục tiêu chính trên mobile.',
      noTrendingPrompts: 'Chưa có prompt nổi bật.',
      fastExploreEyebrow: 'Khám phá nhanh',
      topCategoriesTitle: 'Danh mục đang được dùng nhiều nhất',
      topCategoriesSubtitle: 'Giữ lại cho màn lớn, tránh làm mobile bị phân tán khỏi mục tiêu tìm kiếm và prompt mới.',
      openLibrary: 'Mở toàn bộ thư viện',
      category: 'Danh mục',
      categoryEmpty: 'Chưa có dữ liệu danh mục.',
      forAgents: 'Cho Agents',
      structureTitle: 'Cấu trúc prompt cho vai trò, hệ thống và người dùng',
      structureSubtitle: 'Giữ lại cho màn lớn, tránh làm mobile bị loãng mục tiêu.',
      role: 'Vai trò',
      system: 'Hệ thống',
      user: 'Người dùng',
      rolePrompt: 'Prompt vai trò',
      systemPrompt: 'Prompt hệ thống',
      userPrompt: 'Prompt người dùng',
      ready: 'Sẵn sàng',
      categoryPromptCount: 'prompt',
    },
    browse: {
      title: 'Thị trường prompt',
      sortNewest: 'Mới nhất',
      noResults: 'Không tìm thấy prompt phù hợp',
      adjustFilters: 'Hãy thử điều chỉnh bộ lọc hoặc từ khóa tìm kiếm.',
      clearFilters: 'Xóa toàn bộ bộ lọc',
    },
    detail: {
      back: 'Quay lại',
      verified: 'Đã xác minh',
      contentHeader: 'Nội dung prompt',
      copy: 'Sao chép',
      copySuccess: 'Đã sao chép prompt!',
      unlock: 'Mở khóa',
      purchaseToReveal: 'Mua để xem nội dung đầy đủ',
      getAccessInfo: 'Thanh toán để nhận quyền truy cập đầy đủ vào prompt này.',
      purchaseSuccess: 'Đã mở khóa thành công!',
      purchaseError: 'Không thể xử lý giao dịch',
      payViaQR: 'Thanh toán bằng mã QR',
      orderCode: 'Mã đơn hàng',
      paymentInstruction: 'Chuyển đúng số tiền và nội dung bên dưới để hệ thống đối soát tự động.',
      verifyPayment: 'Tôi đã thanh toán',
      qrTimer: 'Mã QR hết hạn sau',
      guestInfo: 'Thông tin khách hàng',
      guestInfoDesc: 'Nhập thông tin để nhận quyền truy cập prompt mà không cần đăng nhập.',
      verifying: 'Đang kiểm tra...',
      notDetected: 'Hệ thống chưa ghi nhận thanh toán. Vui lòng thử lại sau vài giây.',
      guestSuccess: 'Thanh toán thành công! Bạn đã có quyền truy cập.',
      guestSuccessMessage: 'Quyền truy cập đã được mở. Bạn có thể sao chép prompt ngay trong trang chi tiết.',
      guestSuccessButton: 'Đã hiểu',
      demoTitle: 'Video demo',
      demoSub: 'Xem nhanh cách prompt hoạt động trước khi mở khóa.',
      previewTitle: 'Xem nhanh prompt',
      previewDescription: 'Tóm tắt nhanh nội dung, chỉ số và ngữ cảnh trước khi vào trang chi tiết.',
      views: 'Lượt xem',
      likes: 'Yêu thích',
      suggestedByAI: 'Gợi ý bởi AI',
      previewAction: 'Xem chi tiết',
      detailHeader: 'Chi tiết prompt',
      notFoundTitle: 'Prompt không tồn tại',
      notFoundDesc: 'Nội dung bạn đang tìm không còn khả dụng hoặc đã bị ẩn.',
      quickCopy: 'Sao chép nhanh',
      mobileFirst: 'Tối ưu di động',
      crystalPremium: 'Giao diện sáng cao cấp',
      promptPreview: 'Xem trước prompt',
      modelLabel: 'Mô hình',
      categoryLabel: 'Danh mục',
      freeLabel: 'Miễn phí',
      priceLabel: 'Giá truy cập',
      amountLabel: 'Số tiền',
      ratingTitle: 'Đánh giá người dùng',
    },
    submit: {
      title: 'Tạo',
      titlePart2: 'Prompt',
      sub: 'Đưa prompt chất lượng cao của bạn lên thư viện với trải nghiệm sáng, sạch và tập trung chuyển đổi.',
      edit: 'Chỉnh sửa',
      preview: 'Xem trước',
      formTitle: 'Chi tiết prompt',
      formSub: 'Cung cấp nội dung rõ ràng, mạch lạc và sẵn sàng dùng ngay.',
      labelTitle: 'Tiêu đề',
      labelModel: 'Mô hình',
      labelCategory: 'Danh mục',
      labelPrice: 'Giá (VND)',
      labelDesc: 'Mô tả ngắn',
      labelContent: 'Nội dung prompt',
      labelYoutube: 'Video demo (YouTube)',
      youtubePlaceholder: 'https://www.youtube.com/watch?v=xxxx hoặc https://youtu.be/xxxx',
      youtubeHint: 'Không bắt buộc. Video demo giúp tăng độ tin cậy và tỷ lệ mua.',
      placeholderTitle: 'Ví dụ: Chuyên gia SEO thực chiến',
      placeholderDesc: 'Prompt này giải quyết việc gì, cho ai, đầu ra như thế nào...',
      placeholderContent: 'Nhập nội dung prompt tại đây...',
      btnPublish: 'Đăng bài',
      btnPublishing: 'Đang đăng...',
      btnCancel: 'Hủy',
      successTitle: 'Đã gửi bài thành công!',
      successSub: 'Prompt đang chờ phê duyệt từ quản trị viên.',
      returnBtn: 'Về trang chủ',
      errorSignIn: 'Vui lòng đăng nhập trước khi đăng bài',
      errorSubmit: 'Không thể gửi prompt',
      validation: {
        title: 'Tiêu đề quá ngắn',
        desc: 'Mô tả quá ngắn',
        content: 'Nội dung là bắt buộc',
        category: 'Vui lòng chọn danh mục',
        youtube: 'Liên kết YouTube không hợp lệ',
      },
    },
    admin: {
      title: 'Quản trị',
      pending: 'Chờ duyệt',
      active: 'Đang hoạt động',
      total: 'Tổng số',
      queue: 'Hàng chờ kiểm duyệt',
      postsHeader: 'Quản lý bài đăng',
      empty: 'Không có dữ liệu chờ duyệt.',
      emptyPosts: 'Chưa có bài đăng nào.',
      approve: 'Duyệt',
      reject: 'Từ chối',
      view: 'Xem',
      edit: 'Sửa',
      delete: 'Xóa',
      save: 'Lưu thay đổi',
      deleteConfirm: 'Xác nhận xóa',
      deletePromptTitle: 'Xóa bài đăng này?',
      deletePromptDesc: 'Thao tác này không thể hoàn tác. Bài đăng sẽ bị xóa khỏi hệ thống.',
      actionRecorded: 'Đã ghi nhận tác vụ',
      updateSuccess: 'Đã cập nhật bài đăng',
      deleteSuccess: 'Đã xóa bài đăng',
      statsHeader: 'Thống kê',
      logsHeader: 'Nhật ký thanh toán',
      processed: 'Đã xử lý',
      ignored: 'Bỏ qua',
      failed: 'Lỗi',
      subtitle: 'Theo dõi hệ thống, kiểm duyệt nội dung và vận hành thư viện prompt.',
      statsChart: 'Tổng quan nền tảng',
      moderationHint: 'Duyệt hoặc từ chối các prompt mới được gửi lên.',
      postsHint: 'Quản lý toàn bộ bài đăng, trạng thái duyệt và thông tin tác giả.',
      logsHint: 'Nhật ký webhook SePay theo thời gian thực.',
      author: 'Tác giả',
      submittedAt: 'Ngày gửi',
      amount: 'Số tiền',
      status: 'Trạng thái',
      actions: 'Thao tác',
      approved: 'Đã duyệt',
      rejected: 'Từ chối',
      allPosts: 'Tất cả bài đăng',
      editPromptTitle: 'Chỉnh sửa bài đăng',
      editPromptDesc: 'Cập nhật nội dung, giá bán và liên kết video demo.',
      saveError: 'Không thể lưu thay đổi',
      deleteError: 'Không thể xóa bài đăng',
    },
    profile: {
      settings: 'Cài đặt',
      editProfile: 'Chỉnh sửa hồ sơ',
      myPrompts: 'Prompt của tôi',
      purchased: 'Đã mua',
      favorites: 'Yêu thích',
      earnings: 'Doanh thu',
      withdraw: 'Rút tiền',
      performance: 'Hiệu suất',
      totalViews: 'Tổng lượt xem',
      salesCount: 'Lượt bán',
      noPrompts: 'Bạn chưa có prompt nào',
      noPromptsSub: 'Bắt đầu chia sẻ prompt đầu tiên của bạn ngay hôm nay.',
      noPurchases: 'Bạn chưa mua prompt nào',
      noPurchasesSub: 'Khám phá thư viện để tìm các prompt phù hợp.',
      orders: 'Lịch sử mua hàng',
      orderId: 'Mã đơn',
      status: 'Trạng thái',
      statusPaid: 'Đã thanh toán',
      statusPending: 'Chờ xử lý',
      notSignedInTitle: 'Bạn chưa đăng nhập',
      notSignedInDesc: 'Đăng nhập để quản lý prompt, lượt thích và lịch sử mua hàng.',
      promptLabel: 'Prompt',
      dateLabel: 'Ngày',
      availableBalance: 'Số dư khả dụng',
      favoritesTitle: 'Mục yêu thích',
      mobileFirst: 'Tối ưu di động',
      premiumCreator: 'Nhà sáng tạo cao cấp',
      noTransactions: 'Chưa có lịch sử giao dịch nào.',
    },
    ai: {
      open: 'Trợ lý AI',
      title: 'Trợ lý gợi ý prompt',
      subtitle: 'Nhập nhu cầu để nhận gợi ý prompt, xu hướng và hướng triển khai phù hợp.',
      inputPlaceholder: 'Ví dụ: Tôi cần prompt viết landing page bán khóa học AI',
      createPrompt: 'Gợi ý tạo prompt',
      suggestTrending: 'Xem prompt nổi bật',
      personalize: 'Cá nhân hóa',
      empty: 'Chưa có gợi ý. Hãy nhập nhu cầu hoặc chọn một hành động bên trên.',
    },
    footer: {
      desc: 'Prompt chất lượng cao dành cho ChatGPT, Claude, Grok và các hệ AI phổ biến.',
      rights: 'Bảo lưu mọi quyền.',
    },
    card: {
      optimized: 'Prompt tối ưu AI',
      copied: 'Đã sao chép',
      quickView: 'Xem nhanh',
      detail: 'Chi tiết',
    },
  },
  en: {
    brand: 'Prompt.stv.vn',
    nav: {
      home: 'Home',
      explore: 'Explore',
      submit: 'Submit',
      admin: 'Admin',
      searchPlaceholder: 'Search prompts...',
      signIn: 'Sign in',
      profile: 'Profile',
      logout: 'Log out',
      mobilePost: 'Post prompt',
    },
    auth: {
      welcome: 'Welcome back',
      sub: 'Sign in to access your prompt library',
      login: 'Sign in',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      name: 'Display name',
      loginBtn: 'Sign in now',
      registerBtn: 'Create account',
      loginSuccess: 'Signed in successfully!',
      registerSuccess: 'Account created successfully!',
      invalidCredentials: 'Invalid email or password',
      registerError: 'Email already exists',
      unauthorizedAdmin: 'You do not have access to the admin area',
      sessionExpired: 'Your session has expired',
    },
    home: {
      searchSuggestEmpty: 'No suggestions yet',
      liveInsight: 'Live insight',
      promptReady: 'prompts ready',
      models: 'Models',
      categories: 'Categories',
      likes: 'Likes',
      views: 'Views',
      latestEyebrow: 'Latest',
      latestTitle: 'Newest prompts',
      latestSubtitle: 'Prioritize fresh content high on mobile so users immediately see new prompts.',
      viewAll: 'View all',
      noNewPrompts: 'No new prompts yet.',
      quickFindEyebrow: 'Quick find',
      trendingTitle: 'Most used prompts',
      trendingSubtitle: 'Keep a secondary reference rail after the newest prompts without distracting mobile users.',
      noTrendingPrompts: 'No featured prompts yet.',
      fastExploreEyebrow: 'Quick explore',
      topCategoriesTitle: 'Most used categories',
      topCategoriesSubtitle: 'Keep this on larger screens so mobile stays focused on search and newest prompts.',
      openLibrary: 'Open full library',
      category: 'Category',
      categoryEmpty: 'No category data yet.',
      forAgents: 'For agents',
      structureTitle: 'Prompt structure for role, system, and user',
      structureSubtitle: 'Keep this on larger screens to avoid distracting the mobile goal.',
      role: 'Role',
      system: 'System',
      user: 'User',
      rolePrompt: 'Role prompt',
      systemPrompt: 'System prompt',
      userPrompt: 'User prompt',
      ready: 'Ready',
      categoryPromptCount: 'prompts',
    },
    browse: {
      title: 'Prompt marketplace',
      sortNewest: 'Newest',
      noResults: 'No prompts found',
      adjustFilters: 'Try adjusting your filters or keywords.',
      clearFilters: 'Clear all filters',
    },
    detail: {
      back: 'Back',
      verified: 'Verified',
      contentHeader: 'Prompt content',
      copy: 'Copy',
      copySuccess: 'Prompt copied!',
      unlock: 'Unlock',
      purchaseToReveal: 'Purchase to reveal the full content',
      getAccessInfo: 'Complete the payment to unlock full access to this prompt.',
      purchaseSuccess: 'Unlocked successfully!',
      purchaseError: 'Could not process the transaction',
      payViaQR: 'Pay with QR code',
      orderCode: 'Order code',
      paymentInstruction: 'Transfer the exact amount with the reference below for automatic reconciliation.',
      verifyPayment: 'I have paid',
      qrTimer: 'QR expires in',
      guestInfo: 'Customer details',
      guestInfoDesc: 'Enter your details to unlock this prompt without signing in.',
      verifying: 'Verifying...',
      notDetected: 'Payment has not been detected yet. Please try again in a few seconds.',
      guestSuccess: 'Payment completed! Access granted.',
      guestSuccessMessage: 'Access is unlocked. You can now copy the prompt on the detail page.',
      guestSuccessButton: 'Understood',
      demoTitle: 'Demo video',
      demoSub: 'Preview how the prompt works before unlocking it.',
      previewTitle: 'Quick preview',
      previewDescription: 'See the prompt summary, metrics, and context before opening the detail page.',
      views: 'Views',
      likes: 'Likes',
      suggestedByAI: 'Suggested by AI',
      previewAction: 'View details',
      detailHeader: 'Prompt detail',
      notFoundTitle: 'Prompt not found',
      notFoundDesc: 'The content you are looking for is no longer available or has been hidden.',
      quickCopy: 'Quick copy',
      mobileFirst: 'Mobile-first',
      crystalPremium: 'Crystal light premium',
      promptPreview: 'Prompt preview',
      modelLabel: 'Model',
      categoryLabel: 'Category',
      freeLabel: 'Free',
      priceLabel: 'Access price',
      amountLabel: 'Amount',
      ratingTitle: 'User rating',
    },
    submit: {
      title: 'Create',
      titlePart2: 'Prompt',
      sub: 'Publish high-quality prompts with a bright, polished, conversion-first experience.',
      edit: 'Edit',
      preview: 'Preview',
      formTitle: 'Prompt details',
      formSub: 'Write clear, structured content that is ready to use.',
      labelTitle: 'Title',
      labelModel: 'Model',
      labelCategory: 'Category',
      labelPrice: 'Price (VND)',
      labelDesc: 'Short description',
      labelContent: 'Prompt content',
      labelYoutube: 'Demo video (YouTube)',
      youtubePlaceholder: 'https://www.youtube.com/watch?v=xxxx or https://youtu.be/xxxx',
      youtubeHint: 'Optional. Demo videos increase trust and conversion.',
      placeholderTitle: 'Example: Production SEO strategist',
      placeholderDesc: 'What problem does this prompt solve and for whom?',
      placeholderContent: 'Write your prompt here...',
      btnPublish: 'Publish',
      btnPublishing: 'Publishing...',
      btnCancel: 'Cancel',
      successTitle: 'Prompt submitted successfully!',
      successSub: 'Your prompt is waiting for moderator approval.',
      returnBtn: 'Back home',
      errorSignIn: 'Please sign in before publishing',
      errorSubmit: 'Could not submit the prompt',
      validation: {
        title: 'Title is too short',
        desc: 'Description is too short',
        content: 'Content is required',
        category: 'Please select a category',
        youtube: 'Invalid YouTube link',
      },
    },
    admin: {
      title: 'Admin',
      pending: 'Pending',
      active: 'Active',
      total: 'Total',
      queue: 'Moderation queue',
      postsHeader: 'Post management',
      empty: 'No pending items.',
      emptyPosts: 'No posts yet.',
      approve: 'Approve',
      reject: 'Reject',
      view: 'View',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save changes',
      deleteConfirm: 'Confirm delete',
      deletePromptTitle: 'Delete this post?',
      deletePromptDesc: 'This action cannot be undone. The post will be permanently removed.',
      actionRecorded: 'Action recorded',
      updateSuccess: 'Post updated',
      deleteSuccess: 'Post deleted',
      statsHeader: 'Statistics',
      logsHeader: 'Payment logs',
      processed: 'Processed',
      ignored: 'Ignored',
      failed: 'Failed',
      subtitle: 'Monitor the platform, moderate content, and operate the prompt library.',
      statsChart: 'Platform overview',
      moderationHint: 'Approve or reject newly submitted prompts.',
      postsHint: 'Manage all posts, moderation states, and author information.',
      logsHint: 'Real-time SePay webhook logs.',
      author: 'Author',
      submittedAt: 'Submitted at',
      amount: 'Amount',
      status: 'Status',
      actions: 'Actions',
      approved: 'Approved',
      rejected: 'Rejected',
      allPosts: 'All posts',
      editPromptTitle: 'Edit post',
      editPromptDesc: 'Update content, price, and demo video link.',
      saveError: 'Could not save changes',
      deleteError: 'Could not delete post',
    },
    profile: {
      settings: 'Settings',
      editProfile: 'Edit profile',
      myPrompts: 'My prompts',
      purchased: 'Purchased',
      favorites: 'Favorites',
      earnings: 'Revenue',
      withdraw: 'Withdraw',
      performance: 'Performance',
      totalViews: 'Total views',
      salesCount: 'Sales',
      noPrompts: 'You have not published any prompts yet',
      noPromptsSub: 'Start sharing your first prompt today.',
      noPurchases: 'You have not purchased any prompts yet',
      noPurchasesSub: 'Browse the library to find prompts that fit your workflow.',
      orders: 'Order history',
      orderId: 'Order ID',
      status: 'Status',
      statusPaid: 'Paid',
      statusPending: 'Pending',
      notSignedInTitle: 'You are not signed in',
      notSignedInDesc: 'Sign in to manage prompts, favorites, and purchase history.',
      promptLabel: 'Prompt',
      dateLabel: 'Date',
      availableBalance: 'Available balance',
      favoritesTitle: 'Favorites',
      mobileFirst: 'Mobile-first',
      premiumCreator: 'Premium creator',
      noTransactions: 'No transactions yet.',
    },
    ai: {
      open: 'AI assistant',
      title: 'Prompt assistant',
      subtitle: 'Describe what you need to get prompt ideas, trending picks, and tailored suggestions.',
      inputPlaceholder: 'Example: I need a prompt for an AI course landing page',
      createPrompt: 'Suggest a prompt',
      suggestTrending: 'Show trending prompts',
      personalize: 'Personalize',
      empty: 'No suggestion yet. Enter a need or choose one of the actions above.',
    },
    footer: {
      desc: 'High-quality prompts for ChatGPT, Claude, Grok, and popular AI platforms.',
      rights: 'All rights reserved.',
    },
    card: {
      optimized: 'AI optimized prompt',
      copied: 'Copied',
      quickView: 'Quick view',
      detail: 'Details',
    },
  },
} as const;
